<template>
  <q-page class="flex">
    <q-card style="flex:1">
      <v-map :zoom=10 :center="center">
        <v-icondefault></v-icondefault>
        <v-tilelayer :url="url"></v-tilelayer>
        <v-control position="topright">
          <q-select
              label="تفکیک موقعیت ها به تفکیک پرسنل"
              v-model="selectedEmployee"
              bg-color="white"
              outlined
              :dense="$q.screen.lt.md"
              :options="employeesOptions"
              option-label="UserName"
              input-debounce="0"
              use-input
              clearable
              @filter="filterFn"
              :style="$q.screen.lt.md?'width: 80vw':'width: 20vw'"
              option-value="Auth">
            <template v-slot:append>
              <q-icon name="search"/>
              <q-btn :dense="$q.screen.lt.md" @click.stop round flat icon="settings" color="blue">
                <q-popup-proxy transition-show="flip-up" transition-hide="flip-down">
                  <q-card flat>
                    <q-card-section class="ju">
                      <div class="row justify-center">
                        <q-input :dense="$q.screen.lt.md" class="q-mt-xs" dir="ltr" filled v-model="startDate"
                                 mask="date"
                                 :rules="['date']"
                                 label="تاریخ شروع" clearable>
                          <template v-slot:append>
                            <q-icon name="event" class="cursor-pointer">
                              <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                                <q-date v-model="startDate" calendar="persian">
                                  <div class="row items-center justify-center">
                                    <q-btn v-close-popup label="تایید" color="primary" flat/>
                                  </div>
                                </q-date>
                              </q-popup-proxy>
                            </q-icon>
                          </template>
                        </q-input>
                      </div>
                      <div class="row justify-center">
                        <q-input :dense="$q.screen.lt.md" dir="ltr" filled v-model="endDate" mask="date"
                                 :rules="['date']"
                                 label="تاریخ پایان"
                                 clearable>
                          <template v-slot:append>
                            <q-icon name="event" class="cursor-pointer">
                              <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                                <q-date v-model="endDate" calendar="persian">
                                  <div class="row items-center justify-center">
                                    <q-btn v-close-popup label="تایید" color="primary" flat/>
                                    <q-btn v-close-popup @click="endDate = ToJalaliDate(new Date())" label="امروز" color="primary"
                                           flat/>
                                  </div>
                                </q-date>
                              </q-popup-proxy>
                            </q-icon>
                          </template>
                        </q-input>
                      </div>
                    </q-card-section>
                    <q-card-section>
                      <div class="row">
                        <q-toggle v-model="showVisitLocations" @input="visiLocations" label="محل های بازدید"/>
                      </div>
                      <div class="row">
                        <q-toggle v-model="showCustomersLocation" @input="customerLocations"
                                  label="موقعیت مکانی طرف معامله"/>
                      </div>
                      <div class="row">
                        <q-toggle disable :value="!showVisitLocations && !showCustomersLocation"
                                  label="موقعیت مکانی پرسنل (سی روز گذشته)"/>
                      </div>
                    </q-card-section>
                  </q-card>
                </q-popup-proxy>
              </q-btn>

            </template>
            <template v-slot:option="scope">
              <q-item v-close-popup
                      v-bind="scope.itemProps"
                      v-on="scope.itemEvents">
                <q-item-section>
                  <q-item-label v-html="scope.opt.UserName"></q-item-label>
                </q-item-section>
              </q-item>
            </template>
          </q-select>
        </v-control>
        <v-marker v-if="lastLocation!==''"
                  :lat-lng="[lastLocation.latitude, lastLocation.longitude]">
          <v-icon>
            <q-icon size="lg" color="red-10"
                    name="location_on"/>
          </v-icon>
          <v-popup>
            <q-card flat>
              <q-card-section class="no-padding" v-if="lastLocation.username">
                <q-chip size="sm" square icon-right="support_agent" :label="lastLocation.username"/>
              </q-card-section>
              <q-card-section class="no-padding" v-if="lastLocation.uuid">
                <q-chip size="sm" square icon-right="person"
                        :label="lastLocation.uuid.uuid"/>
              </q-card-section>
              <q-card-section class="no-padding" v-if="lastLocation.logDatetime">
                <q-chip color="red" size="sm" square text-color="white" dir="ltr" outline icon="calendar_today"
                        :label="lastLocation.logDatetime "/>
              </q-card-section>
            </q-card>
          </v-popup>
        </v-marker>
        <v-marker-cluster :options="markerOptions">
          <v-marker v-for="(item, index) in locationOptions"
                    :lat-lng="[item.latitude, item.longitude]"
                    :key="index">
            <v-icon v-if="index===0">
              <q-icon size="lg" :color="index === 0 && lastLocation!==''?'red-10':'indigo-10'"
                      name="location_on"/>
            </v-icon>
            <v-popup>
              <q-card flat>
                <q-card-section class="no-padding" v-if="item.username">
                  <q-chip size="sm" square icon-right="support_agent" :label="item.username"/>
                </q-card-section>
                <q-card-section class="no-padding" v-if="item.uuid">
                  <q-chip :clickable="item.speed!==0" @click="showCustomerInfoDialog(item.speed)" size="sm" square icon-right="person"
                          :label="item.uuid.uuid"/>
                </q-card-section>
                <q-card-section class="no-padding" v-if="item.logDatetime">
                  <q-chip color="red" size="sm" square text-color="white" dir="ltr" outline icon="calendar_today"
                          :label="item.logDatetime "/>
                </q-card-section>
              </q-card>
            </v-popup>
          </v-marker>
        </v-marker-cluster>
      </v-map>
    </q-card>
    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showCustomerFullInfo">
      <CustomerInfo :selected-customer="selectedCustomer"/>
    </q-dialog>
  </q-page>
</template>

<script>
import {mapActions} from "vuex";
import {LMap, LTileLayer, LIconDefault, LMarker, LIcon, LControl, LPopup} from 'vue2-leaflet'
import {latLng} from 'leaflet'
import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster'
import CustomerInfo from "@/components/customers/CustomerInfo";

export default {
  name: "EmployeeLocations",
  components: {
    CustomerInfo,
    'v-map': LMap,
    'v-tilelayer': LTileLayer,
    'v-icondefault': LIconDefault,
    'v-marker': LMarker,
    'v-marker-cluster': Vue2LeafletMarkercluster,
    'v-icon': LIcon,
    'v-control': LControl,
    'v-popup': LPopup
  },
  data() {
    return {
      search: '',
      startDate: '',
      endDate: '',
      zoom: 6,
      center: latLng(0, 0),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; Nooran co',
      locations: [],
      employes: [],
      employeesOptions:[],
      selectedEmployee: [],
      locationOptions: [],
      customers: [],
      isLastLocation: false,
      lastLocation: '',
      visitLocations: [],
      showVisitLocations: false,
      showCustomersLocation: false,
      markerOptions: {},
      selectedCustomer: '',
      showCustomerFullInfo: false,
    }
  },
  methods: {
    ...mapActions({
      getLocations: 'Requests/getLocations',
      getCustomerInfo: 'Customers/get_customer_info'
    }),
    filterFn(val, update) {
      update(() => {
        const needle = val.toLowerCase()
        this.employeesOptions = this.employes.filter(v => v.UserName.indexOf(needle) > -1)
      })
    },
    visiLocations() {
      if (this.showVisitLocations) {
        this.showCustomersLocation = false
        this.locationOptions = this.lodash.orderBy(this.visitLocations, item=> item.logDatetime)
      } else {
        this.locationOptions = this.locations
        this.selectedEmployee = ''
      }
    },
    customerLocations() {
      if (this.showCustomersLocation) {
        this.showVisitLocations = false
        this.locationOptions = this.lodash.orderBy(this.visitLocations, item=> item.logDatetime)
      } else {
        this.locationOptions = this.locations
        this.selectedEmployee = ''
      }
    },
    showCustomerInfoDialog(customerId) {
      this.getCustomerInfo(customerId).then((res) => {
        this.selectedCustomer = res.data[0]
        this.showCustomerFullInfo = true
      })
    },
    loadData() {
      this.getLocations(
          {
            startDate: this.startDate !== '' && this.endDate !== '' ? this.startDate : '',
            endDate: this.startDate !== '' && this.endDate !== '' ? this.endDate : '',
          }).then((res) => {
        this.locations = eval(res.locations)
        if(this.locations && this.locations.length>0){
          this.locationOptions = this.locations
          this.lastLocation = this.locations[0]
          this.center = latLng(this.lastLocation.latitude, this.lastLocation.longitude)
        }
        this.employes = eval(res.usersList)
        this.employeesOptions = this.employes
        this.visitLocations = eval(res.visitList)
        this.customers = eval(res.customers)
      })
    }
  },
  watch: {
    selectedEmployee: function (value) {
      if (!value || value === '') {
        this.locationOptions = this.locations
      } else {
        let founded
        if (this.showVisitLocations === true) {
          founded = this.visitLocations.filter(user => user.username && value.Auth.toLowerCase() === user.Auth.toLowerCase())
        } else {
          founded = this.locations.filter(user =>user.username && value.Auth.toLowerCase() === user.username.toLowerCase())
        }
        if (founded.length > 0) {
          this.locationOptions =this.lodash.orderBy(founded, item=> item.logDatetime)
        } else {
          this.locationOptions = this.locations
        }
        if (this.locationOptions.length > 0) {
          this.lastLocation = this.locationOptions[0]
          this.center = latLng(this.lastLocation.latitude, this.lastLocation.longitude)
        }
      }
    },
    startDate: function () {
      if (this.startDate !== '' && this.endDate !== '') {
        this.loadData()
      }
    },
    endDate: function () {
      if (this.startDate !== '' && this.endDate !== '') {
        this.loadData()
      }
    }
  },
  created() {
    this.loadData()
  }
}
</script>

<style>
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
</style>
